import { useLocation } from 'react-router-dom'

import { FileArrowDown } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { BackListButton, Button, InvoiceType, Text } from '@reveni-io/reveni-ui'

import { openInNewTab } from '@/common/helpers/helpers'

import * as Styles from './styles'

const Header = ({ invoice }) => {
  const theme = useTheme()
  const location = useLocation()

  const getInvoiceNumber = () => {
    if (invoice?.credited_invoice_number) {
      return `#R${invoice?.number}`
    }
    return `#${invoice?.number}`
  }

  const getBackUrl = () => {
    return location.state ? `${location.state?.from?.pathname}${location.state?.from?.search}` : '/billing'
  }

  return (
    <div>
      <BackListButton to={getBackUrl()} />
      <Styles.HeaderContent>
        <Styles.InfoContainer>
          <Text type="titleL" color={theme.colors.outline.default}>
            {getInvoiceNumber()}
          </Text>
          <InvoiceType isCredit={invoice?.credited_invoice_number} showText />
        </Styles.InfoContainer>
        <Styles.ActionsContainer>
          <Button onClick={() => openInNewTab(invoice?.billing_report_file_url)}>
            <FileArrowDown size={18} />
            <span>CSV</span>
          </Button>
          <Button onClick={() => openInNewTab(invoice?.invoice_file_url)}>
            <FileArrowDown size={18} />
            <span>PDF</span>
          </Button>
        </Styles.ActionsContainer>
      </Styles.HeaderContent>
    </div>
  )
}

export default Header
